import _toConsumableArray from "/codebuild/output/src756613865/src/github.com/EverlyWell/www/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import membershipCurrentImage from "../../assets/images/membership-current.jpg";
import membershipControlImage from "../../assets/images/membership-control.jpg";
import membershipControlPromoImage from "../../assets/images/membership-control-promo.jpg";
import membershipCurrentPromoImage from "../../assets/images/membership-current-promo.jpg";
import { ActiveMembershipStatuses } from "../../shared/types";
export var Tag;
!function (e) {
  e.General = "general", e.Men = "men", e.Women = "women", e.EnergyWeight = "energy-weight", e.SexualHealth = "sexual-health", e.COVID = "covid", e.Memberships = "memberships", e.None = "";
}(Tag || (Tag = {}));
export var productCategories = [{
  displayName: "General Wellness",
  slug: Tag.General
}, {
  displayName: "Men's Health",
  slug: Tag.Men
}, {
  displayName: "Women's Health",
  slug: Tag.Women
}, {
  displayName: "Energy + Weight",
  slug: Tag.EnergyWeight
}, {
  displayName: "Sexual Health",
  slug: Tag.SexualHealth
}, {
  displayName: "COVID-19",
  slug: Tag.COVID
}, {
  displayName: "Memberships",
  slug: Tag.Memberships
}];
export var productLinks = function productLinks(e) {
  return [{
    slug: "food-sensitivity-test",
    label: "Food Sensitivity Test",
    url: e + "/products/food-sensitivity/",
    tags: [Tag.General]
  }, {
    slug: "food-sensitivity-comprehensive-test",
    label: "Food Sensitivity Comprehensive Test",
    url: e + "/products/food-sensitivity-comprehensive-test/",
    tags: [Tag.General]
  }, {
    slug: "b-vitamins-test",
    label: "B Vitamins Test",
    url: e + "/products/b-vitamins-test/",
    tags: [Tag.General]
  }, {
    slug: "fit-colon-cancer-screening-test",
    label: "FIT Colon Cancer Screening Test",
    url: e + "/products/fit-colon-cancer-screening-test/",
    tags: [Tag.General]
  }, {
    slug: "folic-acid-test",
    label: "Folic Acid Test",
    url: e + "/products/folic-acid-test/",
    tags: [Tag.General]
  }, {
    slug: "lyme-disease-test",
    label: "Lyme Disease Test",
    url: e + "/products/lyme-disease-test/",
    tags: [Tag.General]
  }, {
    slug: "indoor-outdoor-allergy-test",
    label: "Indoor & Outdoor Allergy Test",
    url: e + "/products/indoor-outdoor-allergy-test/",
    tags: [Tag.General]
  }, {
    slug: "covid-19-test",
    label: "COVID-19 Test Home Collection Kit DTC",
    url: e + "/products/covid-19-test/",
    tags: [Tag.General]
  }, {
    slug: "cholesterol-and-lipids-test",
    label: "Cholesterol and Lipids Test",
    url: e + "/products/cholesterol-and-lipids-test/",
    tags: [Tag.General]
  }, {
    slug: "heart-health-test",
    label: "Heart Health Test",
    url: e + "/products/heart-health-test/",
    tags: [Tag.General]
  }, {
    slug: "hba1c-test",
    label: "HbA1c Test",
    url: e + "/products/hba1c/",
    tags: [Tag.General]
  }, {
    slug: "sleep-and-stress-panel",
    label: "Sleep and Stress Test",
    url: e + "/products/sleep-and-stress-panel/",
    tags: [Tag.General]
  }, {
    slug: "elements-panel",
    label: "Heavy Metals Test",
    url: e + "/products/elements-panel/",
    tags: [Tag.General]
  }, {
    slug: "testosterone-test",
    label: "Testosterone Test",
    url: e + "/products/testosterone-test/",
    tags: [Tag.Men]
  }, {
    slug: "mens-health-test",
    label: "Men's Health Test",
    url: e + "/products/mens-health-test/",
    tags: [Tag.Men]
  }, {
    slug: "hpv-test-female",
    label: "HPV Test - Female",
    url: e + "/products/hpv-test-female/",
    tags: [Tag.Women]
  }, {
    slug: "womens-health-test",
    label: "Women's Health Test",
    url: e + "/products/womens-health-test/",
    tags: [Tag.Women]
  }, {
    slug: "ovarian-reserve-test",
    label: "Ovarian Reserve Test",
    url: e + "/products/ovarian-reserve-test/",
    tags: [Tag.Women]
  }, {
    slug: "perimenopause-test",
    label: "Perimenopause Test",
    url: e + "/products/perimenopause-test/",
    tags: [Tag.Women]
  }, {
    slug: "postmenopause-test",
    label: "Postmenopause Test",
    url: e + "/products/postmenopause-test/",
    tags: [Tag.Women]
  }, {
    slug: "womens-fertility-test",
    label: "Women's Fertility Test",
    url: e + "/products/womens-fertility-test/",
    tags: [Tag.Women]
  }, {
    slug: "thyroid-test",
    label: "Thyroid Test",
    url: e + "/products/thyroid-test/",
    tags: [Tag.EnergyWeight]
  }, {
    slug: "vitamin-d-test",
    label: "Vitamin D Test",
    url: e + "/products/vitamin-d-test/",
    tags: [Tag.EnergyWeight]
  }, {
    slug: "metabolism-test",
    label: "Metabolism Test",
    url: e + "/products/metabolism/",
    tags: [Tag.EnergyWeight]
  }, {
    slug: "vitamin-d-and-inflammation-test",
    label: "Vitamin D and Inflammation Test",
    url: e + "/products/vitamin-d-and-inflammation-test/",
    tags: [Tag.EnergyWeight]
  }, {
    slug: "trichomoniasis-test",
    label: "Trichomoniasis Test",
    url: e + "/products/trichomoniasis-test/",
    tags: [Tag.SexualHealth]
  }, {
    slug: "chlamydia-gonorrhea-test",
    label: "Chlamydia and Gonorrhea Test",
    url: e + "/products/chlamydia-gonorrhea-test/",
    tags: [Tag.SexualHealth]
  }, {
    slug: "hepatitis-c-test",
    label: "Hepatitis C Test",
    url: e + "/products/hepatitis-c-test/",
    tags: [Tag.SexualHealth]
  }, {
    slug: "syphilis-test",
    label: "Syphilis Test",
    url: e + "/products/syphilis-test/",
    tags: [Tag.SexualHealth]
  }, {
    slug: "hiv-test",
    label: "HIV Test",
    url: e + "/products/hiv-test/",
    tags: [Tag.SexualHealth]
  }, {
    slug: "std-test-female",
    label: "STD Test - Female",
    url: e + "/products/std-test-female/",
    tags: [Tag.SexualHealth]
  }, {
    slug: "std-test-male",
    label: "STD Test - Male",
    url: e + "/products/std-test-male/",
    tags: [Tag.SexualHealth]
  }, {
    slug: "individual-covid-19-test",
    label: "COVID-19 Test Home Collection Kit DTC",
    url: e + "/products/covid-19-test/",
    tags: [Tag.COVID]
  }, {
    slug: "ellume-covid-19-test",
    label: "Ellume COVID-19 Home Test",
    url: e + "/products/covid-ellume-rapid-test/",
    tags: [Tag.COVID]
  }, {
    slug: "covid-quidel-rapid-test",
    label: "QuickVue At-Home OTC COVID-19 Test",
    url: e + "/products/covid-quidel-rapid-test/",
    tags: [Tag.COVID]
  }, {
    slug: "business-covid-19",
    label: "COVID Testing for Qualifying Organizations",
    url: e + "/business/covid-19",
    tags: [Tag.COVID]
  }];
};
export var productCards = function productCards(e, t) {
  var s = {
    slug: "control-membership",
    label: "Control –\nProactive Health",
    url: e + "/control-membership/",
    tags: [Tag.Memberships],
    description: "Choose from 14 different health tests and save 50%+ every month.",
    image: {
      alt: "Control — Proactive Health Membership",
      src: membershipControlImage
    },
    cta: "",
    "data-analytics-event": "Clicked Button",
    "data-analytics-label": "navigation-link-control-membership"
  },
      a = {
    slug: "current-membership",
    label: "Current –\nSexual Health",
    url: e + "/current-membership/",
    tags: [Tag.Memberships],
    description: "Choose from 5 different STI tests and save up to 70% every month.",
    image: {
      alt: "Current – Sexual Health Membership",
      src: membershipCurrentImage
    },
    cta: "",
    "data-analytics-event": "Clicked Button",
    "data-analytics-label": "navigation-link-current-membership"
  };

  switch (null == t ? void 0 : t.type) {
    case "current":
      a.cta = "View Dashboard", s.cta = "Become a member";
      break;

    case "control":
      s.cta = "View Dashboard", a.cta = "Become a member";
      break;

    default:
      s.cta = "Become a member", a.cta = "Become a member";
  }

  return [s, a];
};

var showPromoForNonMembers = function showPromoForNonMembers(e) {
  return !e || !ActiveMembershipStatuses.includes(e);
};

export var mainPromo = function mainPromo(e, t) {
  return showPromoForNonMembers(t) ? {
    headline: "New Membership Program",
    "data-analytics-event": "Clicked Button",
    "data-analytics-label": "navigation-promo-control-membership",
    product: {
      slug: "control-membership",
      label: "Choose the test you want for just $24.99 a month.",
      url: e + "/control-membership/",
      tags: [],
      image: {
        alt: "Control – Proactive Health Membership",
        src: membershipControlPromoImage
      }
    }
  } : null;
};
export var promoCards = function promoCards(e) {
  return [{
    headline: "Current Sexual Health Membership",
    "data-analytics-event": "Clicked Button",
    "data-analytics-label": "navigation-promo-current-membership",
    product: {
      slug: "current-membership",
      label: "Proactive sexual health testing for only $14.99 a month.",
      url: e + "/current-membership/",
      tags: [Tag.SexualHealth],
      image: {
        alt: "Current – Sexual Health Membership",
        src: membershipCurrentPromoImage
      }
    }
  }];
};
export var combinedProducts = function combinedProducts(e) {
  return [].concat(_toConsumableArray(productLinks(e)), _toConsumableArray(productCards(e)));
};